// Shared constants for all IPD Billing screens
import { IPD_COLORS } from "../ipd/utils/ipdColors";
import { IPD_SIDEBAR } from "../ipd/utils/ipdSidebar";

export const C = {
  sidebarBg:     IPD_SIDEBAR.bg,
  sidebarHover:  IPD_SIDEBAR.hover,
  sidebarActive: IPD_SIDEBAR.active,
  bg:            IPD_COLORS.pageBg,
  card:          IPD_COLORS.cardBg,
  accent:        IPD_COLORS.selectedBg,
  primary:       IPD_COLORS.primary,
  primaryHover:  IPD_COLORS.primaryDark,
  success:       IPD_COLORS.success.text,
  warning:       IPD_COLORS.warning.text,
  danger:        IPD_COLORS.error.text,
  border:        IPD_COLORS.border,
  text:          IPD_COLORS.textPrimary,
  textSub:       IPD_COLORS.textSecondary,
};

// Single source of truth — update route here, reflects in all sidebar instances
export const NAV = [
  { id: "dashboard",  label: "Dashboard",          icon: "dashboard",  route: "/ipd-billing"                },
  // Patient Journey is hidden from the sidebar: the screen is still routable for anyone
  // holding a link to it, it is simply not offered as somewhere to go.
  // { id: "journey",    label: "Patient Journey",     icon: "journey",    route: "/ipd-billing/journey"        },
  { id: "charge",     label: "Charge Capture",      icon: "charge",     route: "/ipd-billing/charge-capture" },
  { id: "deposit",    label: "Deposits & Refunds",  icon: "deposit",    route: "/ipd-billing/deposits"       },
  { id: "insurance",  label: "Insurance & Claims",  icon: "insurance",  route: "/ipd-billing/insurance"      },
  { id: "invoice",    label: "Invoices",            icon: "invoice",    route: "/ipd-billing/invoices"       },
  { id: "refund-cancel", label: "Refund & Cancel",  icon: "refund",     route: "/ipd-billing/refund-cancel"  },
  // Cash counter & scroll (Part G). Every scroll role holds SCROLL_INTERIM_VIEW,
  // so it gates the whole module; finer actions are gated inside the screens.
  { id: "cash-counter", label: "Cash Counter",      icon: "cash",       route: "/ipd-billing/cash-counter",
    requiresAny: ["SCROLL_INTERIM_VIEW", "SCROLL_FINAL_VIEW", "SCROLL_FINAL_CLOSE"] },
  // Approvals is a supervisor+ inbox. Gate strictly on INVOICE_CANCEL_APPROVE — a
  // supervisor/manager-only permission the Cashier lacks — so cashiers never see it.
  { id: "approvals",  label: "Approvals",           icon: "shield",     route: "/ipd-billing/approvals",
    requiresAny: ["INVOICE_CANCEL_APPROVE"] },
  { id: "ot-approvals", label: "OT Approvals",       icon: "shield",     route: "/ipd-billing/ot-approvals"   },
  { id: "ledger",     label: "Ledger & Audit",      icon: "ledger",     route: "/ipd-billing/ledger"         },
  { id: "discharge",  label: "Discharge War Room",  icon: "discharge",  route: "/ipd-billing/discharge"      },
  { id: "reports",    label: "Reports & Analytics", icon: "reports",    route: "/ipd-billing/reports"        },
  { id: "pricing",    label: "Pricing Rules",       icon: "pricing",    route: "/ipd-billing/pricing"        },
  { id: "payouts",    label: "Doctor Payouts",      icon: "payout",     route: "/ipd-billing/payouts"        },
];

export const getAuthHeaders = (includeJson = false) => {
  const headers = {
    Authorization: `Bearer ${sessionStorage.getItem("accessToken") || ""}`,
    "App-Mode":
      sessionStorage.getItem("APP_MODE") ||
      sessionStorage.getItem("appMode") ||
      "SaaS",
    "Org-Code":
      sessionStorage.getItem("ORG_CODE") ||
      sessionStorage.getItem("orgCode") ||
      "",
    Username:
      sessionStorage.getItem("userName") ||
      sessionStorage.getItem("username") ||
      "",
    "User-Access-Key":
      sessionStorage.getItem("USER_ACCESS_KEY") ||
      sessionStorage.getItem("accessKey") ||
      "",
  };
  if (includeJson) headers["Content-Type"] = "application/json";
  return headers;
};

export const fmtINR = (n) => {
  if (n == null) return "—";
  const abs = Math.abs(n).toLocaleString("en-IN");
  return n < 0 ? `-₹${abs}` : `₹${abs}`;
};

export const fmtLakh = (n) => `₹${(n / 100000).toFixed(1)}L`;
